// lib/koi-pond-v2/lighting/rig.ts
//
// Three-light rig that every koi inherits in Phase 2:
//   1. Key   — warm directional from high angle, simulates sun through water
//   2. Fill  — cool hemispheric ambient, sky/ground bounce
//   3. Rim   — warm from below, simulates upward caustic kick
//
// All colors pull from the locked palette. Returns the three light
// instances so callers can dispose properly (lights don't strictly need
// dispose but the consistency keeps Phase 2 simpler).

import { DirectionalLight, HemisphereLight, Color, type Scene } from 'three';
import { palette } from '../palette';

export type LightingRig = {
  key: DirectionalLight;
  fill: HemisphereLight;
  rim: DirectionalLight;
};

export function mountLightingRig(scene: Scene): LightingRig {
  // Key — warm sun from high front
  const key = new DirectionalLight(new Color(palette.lightShaftCore.hex), 1.2);
  key.position.set(-3, 6, 3);
  scene.add(key);

  // Fill — cool hemispheric (sky = mid-water-light, ground = deepest)
  const fill = new HemisphereLight(
    new Color(palette.midWaterLight.hex),
    new Color(palette.deepestWater.hex),
    0.4,
  );
  scene.add(fill);

  // Rim — warm from below (upward caustic kick)
  const rim = new DirectionalLight(new Color(palette.causticAccent.hex), 0.6);
  rim.position.set(0, -2, 4);
  scene.add(rim);

  return { key, fill, rim };
}
